module.exports = __webpack_public_path__ + "static/media/achievement_04.fc009292.png";